import { render, staticRenderFns } from "./preservationInfoList.vue?vue&type=template&id=28623ac2&scoped=true"
import script from "./preservationInfoList.vue?vue&type=script&lang=js"
export * from "./preservationInfoList.vue?vue&type=script&lang=js"
import style0 from "./preservationInfoList.vue?vue&type=style&index=0&id=28623ac2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28623ac2",
  null
  
)

export default component.exports